import axios from "axios";
import { Configuration } from "./configuration";
import {
  AppBrandControllerApiFactory,
  AppFashionStyleControllerApiFactory,
  AppHomeControllerApiFactory,
  AppPaymentControllerApiFactory,
  AppProductControllerApiFactory,
  AppPromotionControllerApiFactory,
  AppSignupControllerApiFactory,
  AppUserControllerApiFactory,
  AppUserCuratingControllerApiFactory,
  AppUserOfferControllerApiFactory,
  AppUserOrderControllerApiFactory,
  CommonImageControllerApiFactory,
  AppGhtkControllerApiFactory
} from "./api";
import { getCookie } from "cookies-next";

export const API_ADDRESS = process.env.NEXT_PUBLIC_API_URL || "http://localhost:4000";

class APIClientClass {
  public client = axios.create({
    withCredentials: false,
    timeout: 10000,
    headers: {
      "Access-Control-Allow-Credentials": true,
      "Accept-Language": "en",
    },
  });

  constructor() {
    if (typeof window !== "undefined") {
      // Thêm interceptor để cập nhật ngôn ngữ trong header cho mỗi request
      this.client.interceptors.request.use((config) => {
        const lang = window.localStorage.getItem("selectedLanguage") || "en";
        if (config.headers) {
          config.headers["Accept-Language"] = lang;
        }
        const token = getCookie("token");
        config.headers["Authorization"] = undefined;

        if (token && token !== 'null') {
          config.headers["Authorization"] = token;
        }
        return config;
      });
    }
  }
  private readonly configuration = new Configuration();

  readonly AppUser = AppUserControllerApiFactory(
    this.configuration,
    API_ADDRESS,
    this.client,
  );
  readonly AppUserOffer = AppUserOfferControllerApiFactory(
    this.configuration,
    API_ADDRESS,
    this.client,
  );
  readonly AppUserCurating = AppUserCuratingControllerApiFactory(
    this.configuration,
    API_ADDRESS,
    this.client,
  );
  readonly AppHome = AppHomeControllerApiFactory(
    this.configuration,
    API_ADDRESS,
    this.client,
  );
  readonly AppSignUp = AppSignupControllerApiFactory(
    this.configuration,
    API_ADDRESS,
    this.client,
  );
  readonly AppProduct = AppProductControllerApiFactory(
    this.configuration,
    API_ADDRESS,
    this.client,
  );
  readonly AppPayment = AppPaymentControllerApiFactory(
    this.configuration,
    API_ADDRESS,
    this.client,
  );
  readonly AppFashionStyle = AppFashionStyleControllerApiFactory(
    this.configuration,
    API_ADDRESS,
    this.client,
  );
  readonly AppBrand = AppBrandControllerApiFactory(
    this.configuration,
    API_ADDRESS,
    this.client,
  );
  readonly CommonImage = CommonImageControllerApiFactory(
    this.configuration,
    API_ADDRESS,
    this.client,
  );
  readonly AppOrder = AppUserOrderControllerApiFactory(
    this.configuration,
    API_ADDRESS,
    this.client,
  );
  readonly AppPromotion = AppPromotionControllerApiFactory(
    this.configuration,
    API_ADDRESS,
    this.client,
  );  
  readonly AppGhtk = {
    ...AppGhtkControllerApiFactory(
      this.configuration,
      API_ADDRESS,
      this.client,
    ),
  };
}

export const APIClient = new APIClientClass();
